import { render, staticRenderFns } from "./HubRevenueDistributionSettings.vue?vue&type=template&id=a9b4edae"
import script from "./HubRevenueDistributionSettings.vue?vue&type=script&lang=js"
export * from "./HubRevenueDistributionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports